// import { VueTabs, VTab } from 'vue-nav-tabs/dist/vue-tabs.js';
// import 'vue-nav-tabs/themes/vue-tabs.css';
import { Component, Vue } from 'vue-property-decorator';
import AppConfig, { globalSettings } from './app.config';
import Accordion from './components/Accordion.vue';
import AccordionItem from './components/AccordionItem.vue';
import AdminBar from './components/AdminBar';
import Altapay from './components/Altapay.vue';
import AnchorNavbar from './components/AnchorNavbar.vue';
import AnchorNavbarDestination from './components/AnchorNavbarDestination.vue';
// import CombinationSelector from './components/CombinationSelector.vue'; // @deprecated
// import CombinationSlide from './components/CombinationSlide.vue'; // @deprecated
// import CombinationTab from './components/CombinationTab.vue'; // @deprecated
import ContactForm from './components/ContactForm.vue';
import CookieBot from './components/CookieBot.vue';
import CookieConsent from './components/CookieConsent';
import CoronaAnchor from './components/CoronaAnchor.vue';
import CoronaBanners from './components/CoronaBanners.vue';
// import DestinationPrice from './components/DestinationPrice'; // @deprecated
import DiscountBanners from './components/DiscountBanners.vue';
// import EPay from './components/EPay.vue';  // @deprecated
import EnquireForm from './components/EnquireForm.vue';
import EnquireFormFixed from './components/EnquireFormFixed.vue';
import EnquireFormSmall from './components/EnquireFormSmall.vue';
import ExpandableContent from './components/ExpandableContent.vue';
// import FeedBanners from './components/FeedBanners.vue'; // @deprecated
// import Hero from './components/Hero.vue'; // @deprecated
import HorizontalSwiper from './components/HorizontalSwiper.vue';
import HorizontalSwiperButtonUp from './components/HorizontalSwiperButtonUp.vue';
import HorizontalSwiperRounded from './components/HorizontalSwiperRounded.vue';
import NavDesktopDropdown from './components/NavDesktopDropdown.vue';
import NavDesktopItem from './components/NavDesktopItem.vue';
import NavDesktopMenu from './components/NavDesktopMenu.vue';
import NavDropdown from './components/NavDropdown.vue';
// import NavDropdownExtended from './components/NavDropdownExtended.vue';
import NavItem from './components/NavItem.vue';
import NavItemDropdown from './components/NavItemDropdown.vue';
// import NavItemExtended from './components/NavItemExtended.vue';
import NavMenu from './components/NavMenu.vue';
// import NavMenuExtended from './components/NavMenuExtended.vue';
import NavMobileMenu from './components/NavMobileMenu.vue';
// import NavMobileMenuExtended from './components/NavMobileMenuExtended.vue';
import NavMobileMenuSlider from './components/NavMobileMenuSlider.vue';
import NavMobileToggle from './components/NavMobileToggle.vue';
import NewsletterForm from './components/NewsletterForm.vue';
import NewsletterRedirectForm from './components/NewsletterRedirectForm.vue';
import NpsPopup from './components/NpsPopup';
import PhotoSwipeWrapper from './components/PhotoSwipeWrapper.vue';
import PricesCalendar from './components/PricesCalendar.vue';
import ScrollTop from './components/ScrollTop';
import ShareButtons from './components/ShareButtons.vue';
import Swiper from './components/Swiper.vue';
import SwiperSlide from './components/SwiperSlide.vue';
// import TabBrandExplanation from './components/TabBrandExplanation.vue'; // @deprecated
import TourDiscountBanners from './components/TourDiscountBanners.vue';
import TourPrice from './components/TourPrice.vue';
import TourPriceDiscounts from './components/TourPriceDiscounts.vue';
import TourPricesTable from './components/TourPricesTable.vue';
import TrustPilotStars from './components/TrustPilotStars.vue';
import TrustpilotWidget from './components/TrustpilotWidget.vue';
import WorkingHours from './components/WorkingHours.vue';
import YoutubeVideo from './components/YoutubeVideo.vue';
import directives from './directives';
import { EventBus } from './helpers/bus';
import IsMobile from './helpers/isMobile';
import { SlideMenu } from './slide-menu';

import store from './store';

import { namespace } from 'vuex-class';

const ui = namespace('ui');

AppConfig.init();

// Install directives
Object.keys(directives).forEach((key) => {
    Vue.directive(key, directives[key]);
});

const scrollToElement = (event) => {
    const targetElementId = event.currentTarget.dataset.scrollTo;
    const targetElement = document.getElementById(targetElementId);

    const header = document.querySelector('#tcHeader');

    if (targetElement) {
        const topOffset = targetElement.getBoundingClientRect().top;
        let headerHeight = header ? header.getBoundingClientRect().height : 0;

        if (header) {
            const isSticky = header.classList.contains('sticky');
            if (!isSticky) {
                headerHeight = headerHeight * 2;
            }
        }

        window.scrollTo({
            top: window.pageYOffset + topOffset - headerHeight,
            behavior: 'smooth',
        });
    }

    event.preventDefault();
};

EventBus.$on('ready', (): void => {
    if (window.location.href.indexOf('#') > -1) {
        const hash = window.location.href.split('#')[1];
        const el: HTMLElement | null = document.getElementById(hash);
        if (el) {
            setTimeout(() => {
                window.scrollTo({
                    top: el.offsetTop - 100,
                    behavior: 'smooth',
                });
            }, 200);
        }
    }

    // TODO: maybe we need to remove an event before unmount
    document.querySelectorAll('[data-scroll-to]').forEach((element) => {
        element.addEventListener('click', scrollToElement);
    });
});

@Component({
    components: {
        Accordion,
        AccordionItem,
        AdminBar,
        AnchorNavbar,
        AnchorNavbarDestination,
        // CombinationSelector,
        // CombinationSlide,
        // CombinationTab,
        ContactForm,
        CookieBot,
        CookieConsent,
        CoronaAnchor,
        CoronaBanners,
        // DestinationPrice,
        EnquireForm,
        EnquireFormSmall,
        EnquireFormFixed,
        // FeedBanners,
        // Hero,
        TourPrice,
        // TabBrandExplanation,
        NavMenu,
        // NavMenuExtended,
        NavMobileToggle,
        NavMobileMenu,
        // NavMobileMenuExtended,
        NavMobileMenuSlider,
        NavItem,
        // NavItemExtended,
        NavItemDropdown,
        NavDesktopMenu,
        NavDesktopItem,
        NavDesktopDropdown,
        NavDropdown,
        // NavDropdownExtended,
        NewsletterForm,
        NewsletterRedirectForm,
        NpsPopup,
        WorkingHours,
        ExpandableContent,
        HorizontalSwiper,
        HorizontalSwiperButtonUp,
        HorizontalSwiperRounded,
        PhotoSwipeWrapper,
        PricesCalendar,
        ScrollTop,
        DiscountBanners,
        TourDiscountBanners,
        TourPriceDiscounts,
        TourPricesTable,
        TrustPilotStars,
        TrustpilotWidget,
        // EPay,
        Altapay,
        Swiper,
        SwiperSlide,
        YoutubeVideo,
        ShareButtons,
        // VueTabs,
        // VTab,
    },
    store,
})
class App extends Vue {
    @ui.State('enquireFormVisible') protected enquireFormVisible: boolean;
    @ui.Mutation('showEnquireForm') protected showEnquireForm: (isVisible: boolean) => void;
    @ui.Mutation('toggleEnquireForm') protected toggleEnquireForm: (isToggled: boolean) => void;

    protected header: HTMLElement | null;
    protected isTourPage = globalSettings.isTour;
    protected menuSlider: SlideMenu | null;

    public scrollTab(_: number, newTab: Vue | any): void {
        const tabPill: HTMLElement | null = document.querySelector(`li[id="t-${newTab.tabId}"]`);

        if (!tabPill || !tabPill.parentElement || !tabPill.parentElement.parentElement) {
            return;
        }

        EventBus.$emit('scrollTab', { tab: tabPill, container: tabPill.parentElement.parentElement });
    }

    protected handleScroll(): boolean {
        if (this.header) {
            if (window.pageYOffset > 20) {
                this.header.classList.add('sticky');
            } else {
                if (document.body.style.position !== 'fixed') { // check and privent remove sticky on mobile
                    this.header.classList.remove('sticky');
                }
            }
        }
        if (window.pageYOffset > 400) {
            if (!this.enquireFormVisible) {
                this.showEnquireForm(true);
            }
        } else {
            if (this.enquireFormVisible) {
                this.showEnquireForm(false);
            }
        }
        return false;
    }

    protected handleScrollOnTabs(): void {
        // Add scrollable functionality to tabs on desktop
        const elements = document.querySelectorAll<HTMLElement>('.nav-tabs-wrapper');

        elements.forEach((scrollableContainer) => {
            let isDragging = false;
            let startX;
            let scrollLeft;

            scrollableContainer.addEventListener('mousedown', (e) => {
                isDragging = true;
                startX = e.pageX - scrollableContainer.offsetLeft;
                scrollLeft = scrollableContainer.scrollLeft;
            });

            scrollableContainer.addEventListener('mouseleave', () => {
                isDragging = false;
            });

            scrollableContainer.addEventListener('mouseup', () => {
                isDragging = false;
            });

            scrollableContainer.addEventListener('mousemove', (e) => {
                if (!isDragging) {
                    return;
                }

                const x = e.pageX - scrollableContainer.offsetLeft;
                const walk = (x - startX) * 3; // Увеличьте значение умножения для более быстрой прокрутки
                scrollableContainer.scrollLeft = scrollLeft - walk;

                e.stopPropagation();
                e.preventDefault();
            });
        });

        document.addEventListener('DOMContentLoaded', function(this) {

            /* iframe karlachat--window-mobile*/

            /*const url = window.location.href;
            if (url.indexOf('?headless') !== -1) {
                const targetKarla = document.getElementsByClassName('karlachat--window')[0];
                const targetKarlaNode: HTMLElement = targetKarla as HTMLElement;
                if (targetKarlaNode) {
                    targetKarlaNode.setAttribute('src', '');
                    targetKarlaNode.style.display = 'none';
                    setTimeout(() => {
                        targetKarlaNode.setAttribute('src', '');
                        targetKarlaNode.style.display = 'none';
                    }, 1000);
                }
            }*/

            /*const style = document.querySelector('style');
            // targetKarlaNode.appendChild(style);
            if (style && style.textContent) {
                style.textContent += '.karlachat--window {@media print {z-index: -9999 !important;}}';
            }

            const targetKarla = document.getElementsByClassName('karlachat--window');
            if (targetKarla[0]) {
                targetKarla[0].classList.add('u-d-print-none');
            }*/

            /*const targetKarla = document.getElementsByClassName('karlachat--window');
            if (targetKarla[0]) {
                const targetKarlaNode: HTMLElement = targetKarla[0] as HTMLElement;
                const css = '.karlachat--window {@media print {z-index: -9999 !important;}}';
                const style = document.createElement('style');
                targetKarlaNode.appendChild(style);
                style.appendChild(document.createTextNode(css));
            }*/

            /* const observerBody = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutationRecord) {
                    const sliderBlock: HTMLElement = mutationRecord.target as HTMLElement;
                    const backBtnNode = document.getElementById('back-btn');
                    const backBtn: HTMLElement = backBtnNode as HTMLElement;
                    if (sliderBlock.style.transform === 'translateX(0%)') {
                        setTimeout(() => {
                            backBtn.style.display = 'none';
                        }, 100);
                    } else {
                        backBtn.style.display = 'block';
                    }

                });
            });

            const bodyTagTarget = document.getElementById('bodyTag');
            if (bodyTagTarget) {
                const bodyTagTargetEl: HTMLElement = bodyTagTarget as HTMLElement;
                observerBody.observe(bodyTagTargetEl, { attributes : true, attributeFilter : ['style'] });
            } */

            const el = document.getElementById('tourcompass-menu');
            if (el) {
                const slideMenu: HTMLElement = el as HTMLElement;
                this.menuSlider = new SlideMenu(slideMenu, {
                    showBackLink: false,
                });
                const openBtn = document.getElementById('open-menu' );

                if (openBtn) {
                    openBtn.addEventListener( 'click',  () => {
                        this.menuSlider.open();

                        const observer = new MutationObserver(function(mutations) {
                            mutations.forEach(function(mutationRecord) {
                                const sliderBlock: HTMLElement = mutationRecord.target as HTMLElement;
                                const backBtnNode = document.getElementById('back-btn');
                                const backBtn: HTMLElement = backBtnNode as HTMLElement;
                                if (sliderBlock.style.transform === 'translateX(0%)') {
                                    setTimeout(() => {
                                        backBtn.style.display = 'none';
                                    }, 100);
                                } else {
                                    backBtn.style.display = 'block';
                                }
                            });
                        });

                        const target = document.getElementsByClassName('slide-menu__slider');
                        if (target[0]) {
                            const targetNode: HTMLElement = target[0] as HTMLElement;
                            observer.observe(targetNode, { attributes : true, attributeFilter : ['style'] });
                        }
                    });
                }
            }

            const tabsWrapper = document.getElementById('tabsWrapper');
            const scrollLeftBtn = document.createElement('button');
            const scrollRightBtn = document.createElement('button');
            scrollLeftBtn.id = 'scroll-left-btn';
            scrollLeftBtn.classList.add('scroll-btn', 'scroll-left-btn');
            scrollRightBtn.id = 'scroll-right-btn';
            scrollRightBtn.classList.add('scroll-btn', 'scroll-right-btn');

            if (tabsWrapper !== null && !IsMobile.detectMobile()) {
                tabsWrapper.insertAdjacentElement('beforebegin', scrollLeftBtn);
                tabsWrapper.insertAdjacentElement('afterend', scrollRightBtn);
                const updateScrollButtons = () => {
                    const isScrollableLeft = tabsWrapper.scrollLeft > 0 && tabsWrapper.scrollLeft !== 0;
                    const currentWidth = tabsWrapper.clientWidth + tabsWrapper.scrollLeft;
                    const isScrollableRight = tabsWrapper.scrollWidth > currentWidth && tabsWrapper.scrollWidth !== currentWidth;
                    scrollLeftBtn.style.display = isScrollableLeft ? 'block' : 'none';
                    scrollRightBtn.style.display = isScrollableRight ? 'block' : 'none';

                    if (isScrollableLeft && isScrollableRight) {
                        scrollRightBtn.style.display = 'block';
                        scrollLeftBtn.style.display = 'block';
                    } else if (isScrollableLeft) {
                        scrollLeftBtn.style.display = 'block';
                        scrollRightBtn.style.display = 'none';
                    } else if (isScrollableRight) {
                        scrollRightBtn.style.display = 'block';
                        scrollLeftBtn.style.display = 'none';
                    }
                };

                scrollLeftBtn.addEventListener('click', function(e) {
                    tabsWrapper.scrollBy({
                        left: -500,
                        behavior: 'smooth',
                    });
                    updateScrollButtons();
                });

                scrollRightBtn.addEventListener('click', function(e) {
                    tabsWrapper.scrollBy({
                        left: 500,
                        behavior: 'smooth',
                    });
                    updateScrollButtons();
                });

                tabsWrapper.addEventListener('mousemove', updateScrollButtons);
                window.addEventListener('resize', updateScrollButtons);
                updateScrollButtons();
            }
        });
    }

    protected handleHomePageLoading(): void {
        const activeBrandsEl = document.getElementById('activeBrands');
        const activeBrandsMobileEl = document.getElementById('activeBrandsMobile');
        if (activeBrandsEl !== null && activeBrandsMobileEl !== null) {
            if (IsMobile.detectMobile()) {
                activeBrandsEl.style.display = 'none';
                activeBrandsMobileEl.style.display = 'flex';
            } else {
                activeBrandsEl.style.display = 'flex';
                activeBrandsMobileEl.style.display = 'none';
            }
        }
    }

    protected mounted(): void {
        this.header = document.getElementById('tcHeader');
        this.$nextTick(function() {
            this.scroll('visible');
            this.handleScrollOnTabs();
        });
        this.handleHomePageLoading();
        EventBus.$emit('appMounted', this);
    }

    protected scroll(condition): void {
        document.body.style.overflow = condition;
    }
}

export default new App().$mount('#application');



// WEBPACK FOOTER //
// ./src/app.ts